import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import type {
	ClientPropertyTypeEnum,
	PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { getPortfolioRedesignIconStyle } from "web_myplann/Portfolio/Components/Redesign/getPortfolioRedesignIcon";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { svgMarkupToDataUri } from "web_myplann/Shared/Utils/svgDataUri";

const ICON_BOX_SIZE = 40;

type Props = {
	portfolio?: PortfolioListItemResponseDTO;
	propertyType?: ClientPropertyTypeEnum | null;
};

export const RowIcon: FC<Props> = ({ portfolio, propertyType }) => {
	const theme = useTheme();

	if (portfolio?.icon) {
		const svgDataUri = svgMarkupToDataUri(portfolio.icon);
		return (
			<IconBox bg={theme.palette.darkmodeText.white} size={ICON_BOX_SIZE}>
				<Box
					component="img"
					src={svgDataUri}
					alt=""
					sx={{ width: ICON_BOX_SIZE, height: ICON_BOX_SIZE, display: "block" }}
				/>
			</IconBox>
		);
	}

	const iconStyle = getPortfolioRedesignIconStyle(
		theme,
		propertyType ?? undefined,
		portfolio?.domain,
	);

	return (
		<IconBox bg={iconStyle.bg} size={ICON_BOX_SIZE}>
			<iconStyle.Icon size={theme.iconSize.md} color={iconStyle.color} />
		</IconBox>
	);
};
